import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import ime from "../../Assets/IME.jpg";
import yso from "../../Assets/YSO.jpg";
import giz from "../../Assets/GIZ.jpg";
import wwf from "../../Assets/WWF.jpg";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={wwf}
              isBlog={false}
              title="Wordwide Fund For Nature"
              description="Internship at WWF, conducting different activities like sessions on green environment, sessions on clean environement, sessions on use of plastic bags"
              // ghLink="https://github.com/soumyajit4419/Chatify"
              // demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={giz}
              isBlog={false}
              title="GIZ(Health project for federal government pakistan)"
              description="Worked as a data analyst that included data collection, data punching, estimation & data visualization."
              // ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={yso}
              isBlog={false}
              title="YSO(Youth Spirit Organization"
              description="Organized workshops on child education in tribal areas. Training and motivating students for participating in the social activities"
              // ghLink="https://github.com/soumyajit4419/Editor.io"
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ime}
              isBlog={false}
              title="IME(IM Economist Society)"
              description="Events organizer at IM Economist society. Organised different social events, seminars and workshops on economic issues of pakistan"
              // ghLink="https://github.com/soumyajit4419/Plant_AI"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
